export interface DepotDTO {
  id: string;
  montant: number;
  typeApprovisonnement: string;
  statutApprovisonnement: string;
  dateEmission: string;
  dateValidation: string | null;
}

export interface RetraitDTO {
  id: string;
  montant: number;
  statut: string;
  dateEmission: string;
}

export interface FinancialDashboardDTO {
  soldeTotal: number;
  soldeSalaire: number;
  soldeScolarite: number;
  totalEncaissements: number;
  totalEncaissementEspeces: number;
  totalEncaissementEnAttente: number;
  totalPaiementsSalaires: number;
  approvisionnements: DepotDTO[];
  retraits: RetraitDTO[];
  totalFrais: number;
  totalFactureEmise: number;
  totalFacturePaye: number;
  totalFactureEnAttente: number;
  totalSalaireNonPaye: number;
  totalSalairePaye: number;
  monthlyFinanceDataByEcoleId: MonthlyFinanceDataDTO[];
}

export type MonthlyFinanceDataDTO = {
  month: string;
  monthlyEncaissements: number;
  monthlyPaiementsSalaires: number;
};

export type DashboardData = {
  totalEncaissementWave: number;
  totalEncaissementOM: number;
  fraisEncaissement: number;
  soldeScolarite: number;
  totalPaiementWave: number;
  totalPaiementOM: number;
  fraisPaiement: number;
  soldeSalaire: number;
  soldeWaveKoriSchool: number;
  soldeOmKoriSchool: number;
};

export const defaultAdminDashboardData: Readonly<DashboardData> = {
  fraisEncaissement: 0,
  fraisPaiement: 0,
  soldeOmKoriSchool: 0,
  soldeSalaire: 0,
  soldeScolarite: 0,
  soldeWaveKoriSchool: 0,
  totalEncaissementOM: 0,
  totalEncaissementWave: 0,
  totalPaiementOM: 0,
  totalPaiementWave: 0,
};

export const ecoleDefaultValue: Readonly<FinancialDashboardDTO> = {
  approvisionnements: [],
  retraits: [],
  monthlyFinanceDataByEcoleId: [],
  soldeSalaire: 0,
  soldeScolarite: 0,
  soldeTotal: 0,
  totalEncaissements: 0,
  totalFrais: 0,
  totalPaiementsSalaires: 0,
  totalFactureEmise: 0,
  totalFacturePaye: 0,
  totalSalaireNonPaye: 0,
  totalSalairePaye: 0,
  totalEncaissementEnAttente: 0,
  totalEncaissementEspeces: 0,
  totalFactureEnAttente: 0,
};
